<template>
  <div>
    <v-card
      rounded="lg"
      elevation="0"
      class="flex-grow-1"
      :loading="isLoading"
    >
      <v-card-text
        class="px-4 px-md-8"
      >
        <v-list
          dense
          :color="isTransparent ? 'transparent' : 'initial'"
          class="d-flex"
          style="gap: 42px;"
        >
          <v-list-item
            class="px-0"
          >
            <v-list-item-icon>
              <v-icon color="primary">
                mdi-account
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ collaboratorName(candidateData) }}
              </v-list-item-title>
              <v-list-item-subtitle>Prénom</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :href="`tel:${candidateData.mobilephone}`"
            class="px-0"
          >
            <v-list-item-icon>
              <v-icon color="primary">
                mdi-phone
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ candidateData.mobilephone }}
              </v-list-item-title>
              <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :href="`mailto:${candidateData.email}`"
            class="px-0"
          >
            <v-list-item-icon>
              <v-icon color="primary">
                mdi-email
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ candidateData.email }}
              </v-list-item-title>
              <v-list-item-subtitle>E-mail</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions
        class="
          d-flex justify-space-between
          px-4 pt-0 pb-4 px-md-8
        "
      >
        <TableAttachments
          v-if="!showAssignOfferButton"
          :attachments="item.attachments"
          permission="PROSPECT"
        />

        <v-btn
          v-if="showAssignOfferButton"
          color="lightBlue"
          class="text-right white--text"
          :disabled="!canPerformAction('CREATE_APPLICATION')"
          @click="assignOffer"
        >
          Assigner à l'offre
          <v-icon
            right
            dark
          >
            mdi-account-switch
          </v-icon>
        </v-btn>

        <v-spacer />

        <v-btn
          color="primary"
          class="text-right"
          :disabled="!canPerformAction('VIEW_PROSPECT')"
          :to="{ name:'candidate', params: { candidateUuid: candidateData.uuid } }"
        >
          En savoir
          <v-icon
            right
            dark
          >
            mdi-plus
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import { requests } from '@/mixins/requests';
import TableAttachments from '@/components/application/components/TableAttachments.vue';

export default {
  name: 'ListItemForCandidates',
  components: { TableAttachments },
  mixins: [requests],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isTransparent: {
      type: Boolean,
      default: false
    },
    showAssignOfferButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { isLoading: false };
  },
  computed: {
    ...mapState(['activeWorkspace', 'user']),
    ...mapGetters(['canPerformAction']),
    candidateData () {
      // Handles both item structures: { collaborator: { ... } } and { ... }
      return this.item.collaborator || this.item;
    },
    collaboratorName () {
      return collaborator => `${collaborator?.firstname} ${collaborator?.lastname}`;
    },
    formatedDate () {
      return date => (date ? moment(date * 1000).format('DD-MM-YYYY') : '');
    }
  },
  methods: {
    async assignOffer () {
      this.isLoading = true;

      const offerResponse = await requests.getOffer(this.$route.params.offerUuid);

      if (!offerResponse.success) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de la récupération de l\'offre', color: 'error' });
        this.isLoading = false;
        return;
      }

      const { uuid, position, entity } = offerResponse.data;
      const { trade } = position;

      const applicationResponse = await this.saveApplication({
        workspace: 'collaborator',
        status: 'draft',
        isSpontaneousApplication: false,
        positionUuid: position.uuid,
        tradeUuid: trade.uuid,
        entityUuid: entity.uuid,
        offerUuid: uuid,
        collaborator: this.candidateData.uuid,
        recruiter: this.user.uuid,
        recruiterStatus: 'TO_SORT',
        prospectStatus: 'IN_PROCESS',
        source: 'UCPA'
      }, false);

      if (applicationResponse.success) {
        this.$router.push({
          name: 'candidature',
          params: {
            offerUuid: uuid,
            candidatureUuid: applicationResponse.data.uuid
          }
        });
      }

      this.isLoading = false;
    },
    async saveApplication (input, isEditMode) {
      const response = await requests.saveApplication({
        input,
        isEditMode: isEditMode
      });

      if (!response.success) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de l\'enregistrement.', color: 'error' });
      } else {
        this.$store.commit('setSnackbar', { text: 'Enregistrer avec succès.', color: 'success' });
      }

      return response;
    }
  }
};
</script>
